/* <soh-purchase-options> — options come from the JSON in [data-po-options] (product.metafields.soh.purchase_options).
   Only subscription options are selectable here; one-time purchase is the 'buy once' link under the ATC.
   Emits 'soh:option:change' {variantId, sellingPlanId, option} for the ATC button, sticky bar and price blocks. */
class SohPurchaseOptions extends HTMLElement {
  connectedCallback() {
    try { this.options = JSON.parse(this.querySelector('[data-po-options]').textContent); } catch (e) { this.options = []; }
    this.addEventListener('change', (e) => { if (e.target.matches('input[name="soh-option"]')) this.select(e.target.value); });
    const pre = window.SOH && SOH.funnel && SOH.funnel.option;
    const pack = document.documentElement.dataset.pack || 'daily';
    const preQty = pre === 'once' && !this.hasAttribute('data-bundles') ? '1box' : pre;
    const preKey = preQty && (this.options.find(o => o.key === preQty) ? preQty : pack + '-' + preQty);
    const initial = (preKey && this.options.find(o => o.key === preKey && (o.selling_plan_id || this.hasAttribute('data-bundles') || !this.hasAttribute('data-subscriptions')))) ? preKey : (this.querySelector('input[name="soh-option"]:checked') || {}).value || (this.options[0] || {}).key;
    this.select(initial);
  }
  get current() { return this.options.find(o => o.key === this.value) || this.options[0]; }
  select(key) {
    this.value = key;
    const input = this.querySelector('input[name="soh-option"][value="' + key + '"]');
    if (input) input.checked = true;
    const o = this.current; if (!o) return;
    const detail = { option: o, variantId: o.variant_id, sellingPlanId: o.selling_plan_id || '', productId: this.dataset.productId };
    this.dataset.variantId = detail.variantId; this.dataset.sellingPlanId = detail.sellingPlanId;
    document.querySelectorAll('[data-po-price]').forEach(el => el.textContent = SOH.money(o.price));
    document.querySelectorAll('[data-po-compare]').forEach(el => { el.textContent = o.compare_at ? SOH.money(o.compare_at) : ''; el.hidden = !o.compare_at; });
    document.querySelectorAll('[data-po-atc-label]').forEach(el => el.textContent = (o.selling_plan_id ? 'Subscribe' : 'Add to cart') + ' · ' + SOH.money(o.price));
    document.querySelectorAll('[data-po-once]').forEach(el => {
      const total = o.compare_at || o.price; el.dataset.variantId = o.variant_id;
      const label = el.querySelector('[data-po-once-label]'); if (label) label.textContent = 'Or buy once for ' + SOH.money(total) + ', no subscription';
    });
    SOH.emit('soh:option:change', detail);
  }
}
customElements.define('soh-purchase-options', SohPurchaseOptions);

/* <soh-pack-switch> — Pack option (Standard | MENO+) of the ONE Daily Wellness Pack product.
   Sets html[data-pack]; [data-pack-only] blocks show for their pack; [data-pack-src-*] images swap;
   keeps the chosen quantity (1box/3box) when switching. ?pack=meno (or a MENO+ ?variant=) preselects. */
const SOH_MENO_VARIANTS = (window.SOH_MENO_VARIANTS || []).map(String);
function sohSetPack(pack, fromUser) {
  document.documentElement.dataset.pack = pack;
  document.querySelectorAll('[data-pack-set]').forEach(b => b.setAttribute('aria-checked', String(b.dataset.packSet === pack)));
  document.querySelectorAll('[data-pack-src-' + pack + ']').forEach(el => {
    const src = el.getAttribute('data-pack-src-' + pack);
    if (el.tagName === 'IMG') { const ss = el.getAttribute('data-pack-srcset-' + pack); if (ss) el.srcset = ss; else el.removeAttribute('srcset'); el.src = src; }
    else { el.dataset.src = src; el.dataset.srcset = ''; const i = el.querySelector('img'); if (i) { i.removeAttribute('srcset'); i.src = src; } }
    /* if the swapped thumbnail is the active one, show the new image in the main stage too */
    if (el.matches('[data-thumb]') && el.getAttribute('aria-current') === 'true') { const g = el.closest('soh-product-gallery'); const m = g && g.querySelector('[data-main-media]'); if (m) { const ss = m.getAttribute('data-pack-srcset-' + pack); if (ss) m.srcset = ss; else m.removeAttribute('srcset'); m.src = src; } }
  });
  const po = document.querySelector('soh-purchase-options');
  if (po && po.options) { const qty = (po.value || '1box').split('-').pop(); po.select(pack + '-' + qty); }
  if (fromUser) { const u = new URL(location.href); if (pack === 'meno') u.searchParams.set('pack', 'meno'); else u.searchParams.delete('pack'); if (u.href !== location.href) history.replaceState(history.state, '', u); }
}
(() => {
  const q = new URLSearchParams(location.search);
  document.documentElement.dataset.pack = (q.get('pack') === 'meno' || SOH_MENO_VARIANTS.includes(q.get('variant'))) ? 'meno' : 'daily';
})();
class SohPackSwitch extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', e => { const b = e.target.closest('[data-pack-set]'); if (b) sohSetPack(b.dataset.packSet, true); });
    requestAnimationFrame(() => sohSetPack(document.documentElement.dataset.pack || 'daily'));
  }
}
customElements.define('soh-pack-switch', SohPackSwitch);
